module.exports = __webpack_public_path__ + "img/educational_curriculum.cfb3049a.jpg";